import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';
import { ProgramsModel } from 'src/app/Models/esdPrograms.model';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {

  api = environment.ESDapiUrl;
  bulkapi = environment.apiUrl;

  private Ecp_api = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getMyLearningsOfEmployee(UserId: number, employeeId: number): Observable<any> {
    const url = `${this.api}ECPUser/FetchMyLearningsOfEmployee/${UserId}?isEmployeeId=${employeeId}`
    return this.http.get<any>(url);

  }
  GetTopLearners(): Observable<any> {
    const url = `${this.api}Program/GetTopLearners`
    return this.http.get<any>(url);

  }
  getRecommendedProgramsOfEmployee(data: any): Observable<any> {
    
    const url = `${this.api}ECPUser/FetchRecommendedProgramsOfEmployee`
    return this.http.post<any>(url, data);

  }
  GetUserProgramDetailsByEmployeeId(employeeId: number): Observable<any> {
    const url = `${this.api}Employee/GetUserProgramDetailsByEmployeeId?employeeId=${employeeId}`
    return this.http.get<any>(url);

  }
  PostBulkUploadOfCompetencies(data: any): Observable<any> {
    const url = `${this.bulkapi}RefreshEmployeeData/BulkUploadEmployeeCompetencyInfo`
    return this.http.post<any>(url, data);
  }

  PostBulkUploadOfCountries(data: any): Observable<any> {
    const url = `${this.bulkapi}RefreshEmployeeData/BulkUploadEmployeeCountry`
    return this.http.post<any>(url, data);
  }

  PostBulkUploadOfEmployeeStatus(data: any): Observable<any> {
    const url = `${this.bulkapi}RefreshEmployeeData/BulkUploadEmployeeStatus`
    return this.http.post<any>(url, data);
  }

  GetBulkUploadOfEmployees(): Observable<any> {
    const url = `${this.bulkapi}RefreshEmployeeData/Bulkuploademployees`
    return this.http.get<any>(url);
  }


  public getEmpCareerUserInfo(EmpId: Number): Observable<EmployeeModel> {
    return this.http.get<EmployeeModel>(`${this.Ecp_api}ECPUser/GetUserInfo?EmployeeId=${EmpId}`)
  }

  public getMyLearnings(userID: number) {
    return this.http.get(`${this.Ecp_api}ECPUser/FetchMyLearningsOfEmployee/${userID}`);
  }

  public getTopLearners() {
    return this.http.get(`${this.Ecp_api}Program/GetTopLearners`);
  }

  public getEmployeeProgressCounts(model: any) {
    return this.http.post(`${this.Ecp_api}Program/GetEmployeeProgressCounts`, model);
  }

  public getNextLearnings(model: ProgramsModel) {
    return this.http.post(`${this.Ecp_api}ECPUser/FetchRecommendedProgramsOfEmployee`, model);
  }
  public FetchProgramCourseTopicsData(userID: number) {
    const url = `${this.Ecp_api}ECPUser/FetchProgramCourseTopicsData?userId=${userID}`
    return this.http.get<any>(url);
  }
  public fetchProgramCourseStatusData(model: any) {
    return this.http.post(`${this.Ecp_api}ECPUser/FetchProgramCourseStatusData`, model);
  }

  public fetchProgramRequestsCount(requestUserID: number) {
    return this.http.get(`${this.Ecp_api}Request/GetPendingRequestCount?requestUserID=${requestUserID}`);
  }

  public getTeamTopLearners(userID: number) {
    return this.http.get(`${this.Ecp_api}Program/GetTeamTopLearners/${userID}`);
  }

  public getTeamProgressCounts(model: any) {
    return this.http.post(`${this.Ecp_api}Program/GetTeamProgressCounts`, model);
  }

  public getMyTeamCourseCount(model: any) {
    return this.http.post(`${this.Ecp_api}Course/GetTeamCourseStatusCount`, model);
  }

  public getMyProgressCountsForLineChart(model: any) {
    return this.http.post(`${this.Ecp_api}Program/GetMyProgressCounts`, model);
  }
  public getTeamProgressForLineChart(model: any) {
    return this.http.post(`${this.Ecp_api}Program/GetTeamProgress`, model);
  }

  public getTeamProgramDetails(employeeId: number) {
    return this.http.get(`${this.Ecp_api}Program/GetTeamProgramDetails?employeeId=${employeeId}`);
  }

  public getTeamRequestsCount(userId: number) {
    return this.http.get(`${this.Ecp_api}Request/GetTeamPendingRequestCount?requestUserID=${userId}`);
  }

  public getMyTeamCourseDetails(model: any) {
    return this.http.post(`${this.Ecp_api}Program/GetTeamCourseDetails`, model);
  }

  public getManagerProjectInfo(employeeId : number){
    return this.http.get(`${this.Ecp_api}EmployeeCareer/GetProjectsAndEmployeesByManager?managerId=${employeeId}`);
  }

  public getManagerHeirarchy(projectIds : string){
    return this.http.get(`${this.Ecp_api}EmployeeCareer/GetManagerHeirarchy?projectIds=${projectIds}`);
  }

  public getFileDownloadLink(imageId : string) : Observable<any> {
    return this.http.get<any>(`${this.Ecp_api}ECPUser/GetProgramImage?fileId=${imageId}`)
  }
}
